/** Backend validation messages from backend/routes/recipes.js (must stay in sync) */
const KNOWN_RECIPE_SAVE_ERRORS = {
  'A recipe cannot include itself as an ingredient.': 'recipes.errorRecipeCannotIncludeSelf',
  'Cannot add recipe as ingredient: this would create a circular dependency.':
    'recipes.errorCircularRecipeDependency',
};

/**
 * @param {unknown} error — typically Error from apiRequest (message = server `error` field)
 * @param {(key: string) => string} t — i18n translate
 */
export function formatRecipeSaveError(error, t) {
  const raw = error && typeof error.message === 'string' ? error.message.trim() : '';
  if (!raw) return t('recipes.failedToSaveRecipe');
  const i18nKey = KNOWN_RECIPE_SAVE_ERRORS[raw];
  if (i18nKey) return t(i18nKey);
  return raw;
}
